import { render, staticRenderFns } from "./DamagesReview.vue?vue&type=template&id=7664e7e4&scoped=true&"
import script from "./DamagesReview.vue?vue&type=script&lang=js&"
export * from "./DamagesReview.vue?vue&type=script&lang=js&"
import style0 from "./DamagesReview.vue?vue&type=style&index=0&id=7664e7e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7664e7e4",
  null
  
)

export default component.exports